export default function splitRow(className = 'anime-text', classNameRow = 'js-row') {
    const arrContentCheck = document.querySelectorAll(`.${className}`)

    if (arrContentCheck) {
        for (const content of arrContentCheck) {
            if (content.querySelectorAll(`.${classNameRow}`)) {
                const contentNew = []

                for (const row of content.querySelectorAll(`.${classNameRow}`)) {
                    contentNew.push(row.innerHTML)
                }

                if (contentNew.length) {
                    content.innerHTML = contentNew.join('')
                }
            }
        }

        const arrContent = document.querySelectorAll(`.${className}`)

        for (const content of arrContent) {
            content.innerHTML = content.innerHTML.split("-").join("-ъ ")
        }

        const arrContentEdit = document.querySelectorAll(`.${className}`)

        for (const content of arrContentEdit) {
            const opentag = `<span class="${classNameRow}">`
            const closingtag = '</span> '

            if (content.children && content.children[0] && content.children[0].tagName && content.children[0].tagName === 'P') {
                for (const contentP of content.children) {
                    const spans = contentP.children
                    let top = 0
                    let tmp = opentag
                    let start = false
                    let contentFormat = contentP.innerHTML

                    contentFormat = contentFormat.split('<br>').join(' <br>')
                    contentFormat = contentFormat.split('<br/>').join(' <br>')
                    contentFormat = contentFormat.split('<br />').join(' <br>')

                    const contentSplit = contentFormat.split(/ (?=[^>]*(?:<|$))/)

                    if (contentSplit && contentSplit.length) {
                        let contentNew = ''

                        for (const data of contentSplit) {
                            // contentNew += '<n>' + data + ' </n>'

                            const isBrTag = data.includes('<br>')
                            const dataNew = data.split('<br>').join('')
                            contentNew += `${isBrTag ? '<br>' : ''}<n>` + dataNew + ' </n>'
                        }

                        if (contentNew) {
                            contentP.innerHTML = contentNew

                            for (let i = 0; i < spans.length; i++) {
                                if (spans[i].innerHTML.trim()) {
                                    const rect = spans[i].getBoundingClientRect().top

                                    if (top < rect && start) {
                                        tmp += closingtag + opentag
                                    }

                                    start = true
                                    top = rect
                                    tmp += spans[i].innerHTML + ' '
                                }
                            }

                            contentP.innerHTML = tmp += closingtag
                        }
                    }
                }
            } else {
                const spans = content.children
                let top = 0
                let tmp = opentag
                let start = false
                let contentFormat = content.innerHTML

                contentFormat = contentFormat.split('<br>').join(' <br>')
                contentFormat = contentFormat.split('<br/>').join(' <br>')
                contentFormat = contentFormat.split('<br />').join(' <br>')

                const contentSplit = contentFormat.split(/ (?=[^>]*(?:<|$))/)

                if (contentSplit && contentSplit.length) {
                    let contentNew = ''

                    for (const data of contentSplit) {
                        // const dataNew = data.split('<br>').join('<brv2>')
                        // contentNew += `<n${isBrTag ? ' style="display:block;"' : ''}>` + dataNew + ' </n>'

                        const isBrTag = data.includes('<br>')
                        const dataNew = data.split('<br>').join('')
                        contentNew += `${isBrTag ? '<br>' : ''}<n>` + dataNew + ' </n>'
                    }

                    if (contentNew) {
                        content.innerHTML = contentNew

                        for (let i = 0; i < spans.length; i++) {
                            if (spans[i].innerHTML.trim()) {
                                const rect = spans[i].getBoundingClientRect().top

                                if (top < rect && start) {
                                    tmp += closingtag + opentag
                                }

                                start = true
                                top = rect

                                tmp += spans[i].innerHTML + ' '
                            }
                        }

                        content.innerHTML = tmp += closingtag
                    }
                }
            }
        }

        const arrContentEnd = document.querySelectorAll(`.${className}`)

        for (const content of arrContentEnd) {
            content.innerHTML = content.innerHTML.split("-ъ ").join("-")
            content.innerHTML = content.innerHTML.split(" -").join("-")
            content.innerHTML = content.innerHTML.split("- ").join("-")
        }
    }
}